
export class SeuilEgalimDto {

  label: string;
  seuil: number;


  constructor(label: string, seuil: number) {
    this.label = label;
    this.seuil = seuil;
  }
}
